module.exports = __webpack_public_path__ + "static/media/displacement.3fb56a28.svg";